import { useParams, Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import { articles, categories, reviews } from '@/mocks/data';
import { WebPageSchema, BreadcrumbListSchema, ArticleSchema } from '@/components/base/SchemaOrg';

const articleImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20cinematic%20scene%20of%20a%20luxury%20hotel%20corridor%20at%20night%2C%20mysterious%20atmosphere%2C%20silhouette%20of%20two%20people%2C%20warm%20dim%20lighting%2C%20noir%20style%2C%20dark%20background%2C%20editorial%20photography%2C%20high%20contrast%2C%20elegant%20composition%2C%20soft%20shadows&width=1200&height=600&seq=detail-01&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=A%20dark%20minimalist%20scene%20with%20scattered%20financial%20documents%20on%20a%20glossy%20black%20desk%2C%20dramatic%20lighting%20from%20above%2C%20red%20seal%20stamps%2C%20luxury%20atmosphere%2C%20editorial%20style%2C%20dark%20background&width=1200&height=600&seq=detail-02&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=A%20dark%20TV%20studio%20set%20with%20dramatic%20red%20and%20blue%20stage%20lighting%2C%20empty%20chairs%2C%20tense%20atmosphere%2C%20scattered%20props%20on%20floor%2C%20cinematic%20style%2C%20dark%20background&width=1200&height=600&seq=detail-03&orientation=landscape',
  4: 'https://readdy.ai/api/search-image?query=An%20empty%20movie%20theater%20with%20red%20seats%20in%20darkness%2C%20single%20projector%20beam%20cutting%20through%2C%20eerie%20atmosphere%2C%20cinematic%20noir%20style%2C%20dark%20background%2C%20high%20contrast&width=1200&height=600&seq=detail-04&orientation=landscape',
  5: 'https://readdy.ai/api/search-image?query=A%20dark%20scene%20of%20a%20streaming%20studio%20with%20multiple%20screens%20showing%20chat%20messages%2C%20dim%20pink%20and%20purple%20ambient%20lighting%2C%20empty%20gaming%20chair%2C%20cyberpunk%20vibe&width=1200&height=600&seq=detail-05&orientation=landscape',
  6: 'https://readdy.ai/api/search-image?query=A%20dark%20dramatic%20scene%20of%20a%20director%20chair%20on%20an%20empty%20film%20set%2C%20spotlight%20casting%20long%20shadows%2C%20mysterious%20atmosphere%2C%20cinematic%20noir%20style%2C%20minimalist&width=1200&height=600&seq=detail-06&orientation=landscape',
  7: 'https://readdy.ai/api/search-image?query=A%20dark%20romantic%20scene%20with%20two%20matching%20luxury%20bracelets%20on%20black%20velvet%2C%20soft%20moody%20lighting%2C%20mysterious%20atmosphere%2C%20editorial%20photography%2C%20high%20contrast&width=1200&height=600&seq=detail-07&orientation=landscape',
  8: 'https://readdy.ai/api/search-image?query=A%20dark%20scene%20of%20a%20talent%20show%20stage%20with%20voting%20screens%20showing%20numbers%2C%20dramatic%20blue%20and%20red%20lighting%2C%20empty%20audience%20seats%2C%20cinematic%20style&width=1200&height=600&seq=detail-08&orientation=landscape',
  9: 'https://readdy.ai/api/search-image?query=A%20dark%20scene%20of%20luxury%20brand%20products%20shattered%20on%20black%20marble%20floor%2C%20dramatic%20lighting%2C%20broken%20glass%20reflections%2C%20luxury%20noir%20style&width=1200&height=600&seq=detail-09&orientation=landscape',
  10: 'https://readdy.ai/api/search-image?query=A%20dark%20office%20scene%20with%20empty%20desks%20under%20dim%20fluorescent%20lighting%2C%20overtime%20atmosphere%2C%20abandoned%20coffee%20cups%2C%20dystopian%20corporate%20vibe&width=1200&height=600&seq=detail-10&orientation=landscape',
  11: 'https://readdy.ai/api/search-image?query=A%20dark%20scene%20of%20contract%20documents%20with%20red%20seals%20on%20black%20desk%2C%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20corporate%20noir%20style&width=1200&height=600&seq=detail-11&orientation=landscape',
  12: 'https://readdy.ai/api/search-image?query=A%20dark%20dramatic%20scene%20of%20a%20wedding%20ring%20broken%20in%20half%20on%20black%20surface%2C%20moody%20lighting%2C%20emotional%20atmosphere%2C%20cinematic%20minimalist%20style&width=1200&height=600&seq=detail-12&orientation=landscape',
};

const relatedImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20cinematic%20scene%20of%20a%20luxury%20hotel%20corridor%20at%20night%2C%20mysterious%20atmosphere%2C%20noir%20style%2C%20dark%20background%2C%20editorial%20photography%2C%20high%20contrast&width=600&height=400&seq=related-01&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=A%20dark%20minimalist%20scene%20with%20scattered%20financial%20documents%20on%20a%20glossy%20black%20desk%2C%20dramatic%20lighting%2C%20editorial%20style%2C%20dark%20background%2C%20high%20contrast&width=600&height=400&seq=related-02&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=A%20dark%20TV%20studio%20set%20with%20dramatic%20red%20and%20blue%20stage%20lighting%2C%20empty%20chairs%2C%20cinematic%20style%2C%20dark%20background&width=600&height=400&seq=related-03&orientation=landscape',
  4: 'https://readdy.ai/api/search-image?query=An%20empty%20movie%20theater%20with%20red%20seats%20in%20darkness%2C%20single%20projector%20beam%2C%20cinematic%20noir%20style%2C%20dark%20background&width=600&height=400&seq=related-04&orientation=landscape',
  7: 'https://readdy.ai/api/search-image?query=A%20dark%20romantic%20scene%20with%20two%20matching%20luxury%20bracelets%20on%20black%20velvet%2C%20soft%20moody%20lighting%2C%20editorial%20photography&width=600&height=400&seq=related-07&orientation=landscape',
  9: 'https://readdy.ai/api/search-image?query=A%20dark%20scene%20of%20luxury%20brand%20products%20shattered%20on%20black%20marble%20floor%2C%20dramatic%20lighting%2C%20luxury%20noir%20style&width=600&height=400&seq=related-09&orientation=landscape',
  12: 'https://readdy.ai/api/search-image?query=A%20dark%20dramatic%20scene%20of%20a%20wedding%20ring%20broken%20in%20half%20on%20black%20surface%2C%20moody%20lighting%2C%20cinematic%20minimalist%20style&width=600&height=400&seq=related-12&orientation=landscape',
  6: 'https://readdy.ai/api/search-image?query=A%20dark%20dramatic%20scene%20of%20a%20director%20chair%20on%20an%20empty%20film%20set%2C%20spotlight%20casting%20shadows%2C%20cinematic%20noir%20style&width=600&height=400&seq=related-06&orientation=landscape',
};

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const article = articles.find((a) => a.id === Number(id));

  if (!article) {
    return (
      <>
        <Header />
        <main className="min-h-screen flex items-center justify-center pt-16">
          <div className="text-center">
            <h1 className="text-2xl font-heading font-bold text-foreground-50 mb-2">文章不存在</h1>
            <p className="text-foreground-500 mb-4">该爆料可能已被删除或链接有误</p>
            <Link to="/" className="text-primary-400 hover:text-primary-300 transition-colors">返回首页</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const category = categories.find((c) => c.slug === article.category);
  const relatedArticles = articles
    .filter((a) => a.id !== article.id)
    .sort(() => 0.5 - Math.random())
    .slice(0, 4);

  return (
    <>
      <WebPageSchema
        pageUrl={`http://921xwm.cn/article/${article.id}`}
        pageName={`${article.title} - 51爆料网`}
        description={article.summary}
      />
      <BreadcrumbListSchema
        items={[
          { name: '首页', url: 'http://921xwm.cn/' },
          { name: category?.name || '分类', url: `http://921xwm.cn/category/${article.category}` },
          { name: article.title, url: `http://921xwm.cn/article/${article.id}` },
        ]}
      />
      <ArticleSchema
        headline={article.title}
        url={`http://921xwm.cn/article/${article.id}`}
        imageUrl={articleImages[article.id]}
        datePublished={article.publishDate}
        authorName={article.author}
        description={article.summary}
      />

      <Header />

      <main>
        {/* Hero */}
        <section className="relative w-full min-h-[400px] md:min-h-[500px] flex items-center overflow-hidden">
          <div className="absolute inset-0 z-0">
            <img
              src={articleImages[article.id]}
              alt={article.title}
              className="w-full h-full object-cover object-top"
              loading="eager"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-50" />
          </div>

          <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
            <div className="max-w-4xl mx-auto">
              <nav aria-label="面包屑导航" className="mb-4">
                <ol className="flex items-center gap-2 text-sm text-foreground-400 flex-wrap">
                  <li><Link to="/" className="hover:text-primary-400 transition-colors">首页</Link></li>
                  <li><span className="text-foreground-600">/</span></li>
                  <li>
                    <Link to={`/category/${article.category}`} className="hover:text-primary-400 transition-colors">
                      {category?.name || '分类'}
                    </Link>
                  </li>
                  <li><span className="text-foreground-600">/</span></li>
                  <li><span className="text-foreground-500 truncate max-w-[200px] inline-block align-bottom">{article.title}</span></li>
                </ol>
              </nav>

              <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-50 leading-tight mb-4">
                {article.title}
              </h1>

              <div className="flex flex-wrap items-center gap-4 text-sm text-foreground-500">
                <div className="flex items-center gap-1.5">
                  <i className="ri-user-line text-primary-400" />
                  <span>{article.author}</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <i className="ri-time-line text-primary-400" />
                  <time dateTime={article.publishDate}>{article.publishDate}</time>
                </div>
                {category && (
                  <Link
                    to={`/category/${article.category}`}
                    className="flex items-center gap-1.5 text-primary-400 hover:text-primary-300 transition-colors"
                  >
                    <i className="ri-price-tag-3-line" />
                    <span>{category.name}</span>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </section>

        {/* Core Content - using about-style layout */}
        <section className="py-10 md:py-14 px-4 md:px-6">
          <div className="max-w-3xl mx-auto">
            <div className="flex justify-center mb-8">
              <span className="px-4 py-1.5 bg-primary-500/10 border border-primary-500/30 text-primary-400 text-xs font-medium rounded-full whitespace-nowrap">
                核心爆料
              </span>
            </div>

            <div
              className="prose prose-invert max-w-none
                prose-p:text-foreground-300 prose-p:leading-relaxed prose-p:text-base prose-p:mb-5
                prose-strong:text-foreground-100 prose-strong:font-semibold
                prose-a:text-primary-400 prose-a:no-underline hover:prose-a:text-primary-300"
              dangerouslySetInnerHTML={{ __html: article.contentHtml }}
            />

            <div className="flex items-center gap-4 mt-10 pt-8 border-t border-background-300/30">
              <div className="flex items-center gap-2 text-foreground-500 text-sm">
                <i className="ri-eye-line text-primary-400" />
                <span>{article.views >= 10000 ? `${(article.views / 10000).toFixed(1)}万次阅读` : `${article.views}次阅读`}</span>
              </div>
              <div className="flex items-center gap-2 text-foreground-500 text-sm">
                <i className="ri-chat-3-line text-primary-400" />
                <span>{article.comments}条评论</span>
              </div>
              {article.tag && (
                <span className="ml-auto px-3 py-1 bg-accent-500/15 border border-accent-500/30 text-accent-400 text-xs font-medium rounded-full whitespace-nowrap">
                  {article.tag}
                </span>
              )}
            </div>
          </div>
        </section>

        {/* User Reviews */}
        <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <div className="relative bg-background-200/70 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row gap-8 lg:gap-12 overflow-hidden">
              <div className="absolute top-0 right-0 w-48 h-48 opacity-[0.03]">
                <i className="ri-chat-quote-line text-foreground-50 text-[160px]" />
              </div>

              <div className="relative lg:w-1/3">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50 mb-2">
                  精选热评
                </h2>
                <p className="text-foreground-500 text-sm">看看吃瓜群众怎么说</p>
              </div>

              <div className="relative lg:w-2/3 space-y-6">
                {reviews.map((review) => (
                  <div key={review.id} className="border-l-2 border-primary-500/40 pl-4">
                    <div className="flex items-center gap-2 mb-2">
                      <div className="w-8 h-8 rounded-full bg-background-400 flex items-center justify-center">
                        <span className="text-foreground-300 font-heading font-bold text-sm">
                          {review.user.charAt(0)}
                        </span>
                      </div>
                      <div>
                        <p className="text-foreground-300 text-sm font-medium">{review.user}</p>
                        <p className="text-foreground-600 text-xs">{review.date}</p>
                      </div>
                      <div className="ml-auto flex items-center gap-0.5">
                        {Array.from({ length: review.rating }).map((_, i) => (
                          <i key={i} className="ri-star-fill text-amber-400 text-xs" />
                        ))}
                      </div>
                    </div>
                    <p className="text-foreground-400 text-sm leading-relaxed italic">
                      &ldquo;{review.content}&rdquo;
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Related Articles */}
        <section className="py-10 md:py-14 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50 mb-8">
              相关爆料
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {relatedArticles.map((related) => (
                <article key={related.id} className="group relative rounded-lg overflow-hidden bg-background-200/70 hover:bg-background-200 transition-colors duration-300">
                  <Link to={`/article/${related.id}`} className="block">
                    <div className="relative h-44 md:h-48 overflow-hidden">
                      <img
                        src={relatedImages[related.id] || relatedImages[1]}
                        alt={related.title}
                        title={related.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-background-200/90 via-transparent to-transparent" />
                    </div>
                    <div className="p-3">
                      <h3 className="text-foreground-200 font-heading font-medium text-xs leading-snug line-clamp-2 group-hover:text-primary-400 transition-colors">
                        {related.title}
                      </h3>
                      <p className="text-foreground-600 text-xs mt-1.5">{related.publishDate}</p>
                    </div>
                  </Link>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 leading-tight mb-4">
              吃瓜<span className="text-primary-400 italic">不停</span>，
              <br className="hidden sm:block" />
              关注<span className="text-foreground-200">51爆料网</span>后续更新
            </h2>
            <p className="text-foreground-500 text-sm mb-8 max-w-lg mx-auto">
              更多独家八卦、往期精华免费回顾，立即查看最新爆料
            </p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap text-sm"
            >
              返回首页吃更多瓜 <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}